import { cva } from 'class-variance-authority';

const avatarBaseStyles = [
  'rounded-full',
  'font-semibold',
  'text-[15px]',
  'w-[46px]',
  'aspect-square',
  'flex',
  'items-center',
  'justify-center',
  'text-center',
  'select-none',
];

const avatarStylesSAG = cva([
  ...avatarBaseStyles,
  'border-2',
  'border-solid',
  'border-[#E5E5E9]',
  'bg-[#E5E5E9]',
  'text-[#000028]',
  'dark:bg-transparent',
  'dark:text-white',
  'dark:border-white'
]);

const avatarStylesSHS = cva([
  ...avatarBaseStyles,
  'bg-[#e6e6e6]',
  'text-[#666666]',
]);

export { avatarStylesSAG, avatarStylesSHS };
